import React from 'react';
import { Box, Typography } from '@mui/material';
import { ErrorStateProps } from '../types';

const ErrorState: React.FC<ErrorStateProps> = ({ error, subtitle }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      height: '100%'
    }}>
      <Typography variant="h6" color="error" sx={{ mb: 2 }}>
        {error}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: subtitle ? 1 : 0 }}>
        {subtitle || 'Failed to load operations'}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default ErrorState;
